Ext.define('SA.view.util.TextWrap', {
    singleton: true,

    getCharsByLine(text, fontSize, maxWidth) {
        var el = this._getEl(),
            textChars = Array.from(text),
            range = document.createRange(),
            priorCharLeft = null,
            lines = [],
            lineIndex = 0,
            textNode;

        el.style.fontSize = fontSize;
        el.style.maxWidth = maxWidth + 'px';

        el.textContent = text;

        textNode = el.childNodes[0];

        textChars.forEach((char, i) => {
            let lineChars, charLeft;

            range.setStart(textNode, i);
            range.setEnd(textNode, i + 1);

            charLeft = range.getBoundingClientRect().left;

            if (priorCharLeft !== null && charLeft < priorCharLeft) {
                lineIndex++;
                priorCharLeft = null;
            }
            else {
                priorCharLeft = charLeft;
            }

            lineChars = lines[lineIndex] = (lines[lineIndex] || []);

            lineChars.push(char);
        });

        return lines;
    },

    _getEl() {
        if (!this.el) {
            this.el = d3.select('body')
                .append('div')
                .style('letter-spacing', '0.2px')
                .style('overflow-wrap', 'break-word')
                .style('position', 'absolute')
                .style('left', '-10000px');
        }

        return this.el.node();
    }
});